<template>
    <div class="vertical-bar-chart">
        <Bar
            ref="barChart"
            :data="chartData"
            :options="options"
            style="max-height: 500px; position: relative"
        />

        <!-- Custom legend -->
        <div class="bar-legend">
            <ul>
                <el-checkbox-group v-model="checkedActivities" class="flex-level jc-center">
                    <el-checkbox
                        v-for="(dataset, index) in data.datasets"
                        :key="index"
                        checked
                        :label="index"
                        class="mr-6"
                        @change="(isChecked) => handleFilterLegendChange(isChecked, index)"
                    >
                        <chip-label
                            :color="dataset.backgroundColor"
                            :label="dataset.label"
                            gap="small"
                        />
                    </el-checkbox>
                </el-checkbox-group>
            </ul>
        </div>
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs';
import ChipLabel from 'vcomponents/utilities/ChipLabel.vue';
import { Chart as ChartJS, Tooltip, BarElement, CategoryScale, LinearScale } from 'chart.js';
ChartJS.register(Tooltip, BarElement, CategoryScale, LinearScale);

export default {
    name: 'VerticalBarChart',
    components: {
        ChipLabel,
        Bar,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            options: null,
            checkedActivities: [],
        };
    },
    computed: {
        chartData() {
            const datasets = this.data.datasets.map((dataset) => ({
                ...dataset,
                data: dataset.data.map((count) => (!count ? null : count)),
                barThickness: 25,
                borderRadius: 100,
            }));
            return { ...this.data, datasets };
        },
    },
    created() {
        this.setOptions();
    },
    mounted() {
        this.$nextTick(() => {
            this.data.datasets.forEach((_, index) =>
                this.handleFilterLegendChange(this.checkedActivities.includes(index), index),
            );
        });
    },
    methods: {
        handleFilterLegendChange(isChecked, index) {
            const ci = this.$refs.barChart.chart;
            const meta = ci.getDatasetMeta(index);

            meta.hidden = !isChecked;
            ci.update();
        },
        /**
         * Set needed options for vertical bar chart
         */
        setOptions() {
            this.options = {
                responsive: true,
                maintainAspectRatio: false,
                font: {
                    family: 'var(--font-families-lato), sans-serif',
                    size: 14,
                    style: 'normal',
                },
                color: '#5C5C65',
                scales: {
                    x: {
                        beginAtZero: false,
                        position: 'bottom',
                        stacked: true,
                        border: {
                            display: false,
                        },
                        grid: {
                            display: false,
                            color: '#D8D8E6',
                            drawTicks: false,
                        },
                        ticks: {
                            fontFamily: 'var(--font-families-lato), sans-serif',
                            fontSize: 14,
                            fontColor: '#5C5C65',
                            padding: 12,
                        },
                    },
                    y: {
                        beginAtZero: true,
                        position: 'left',
                        stacked: true,
                        border: {
                            dash: [5, 5],
                        },
                        grid: {
                            lineWidth: (context) => (context.index === 0 ? 0 : 1),
                            display: true,
                            color: '#D8D8E6',
                            drawTicks: false,
                        },
                        ticks: {
                            stepSize: 1,
                            fontFamily: 'var(--font-families-lato), sans-serif',
                            fontSize: 14,
                            fontColor: '#5C5C65',
                            padding: 12,
                        },
                    },
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                animation: {
                    duration: 400,
                },
            };
        },
    },
};
</script>
